import axios from "axios";
import config from "../config";

// content type
axios.defaults.headers.post["Content-Type"] = "application/json";
axios.defaults.baseURL = config.API_URL;

export const NotesService = {
  getAddressNotes: (addressId: number) => {
    const fullUrl = `api/Addresses/Notes/${addressId}`;
    return axios.get(fullUrl);
  },

  updateAddressNotes: (addressId: number, btShipmentId: string, notes: string) => {
    const fullUrl = `api/Addresses/Notes/${addressId}/${btShipmentId}`;
    return axios.put(fullUrl, { Notes: notes });
  },
};

export type AddressNote = {
  id: number;
  parentNoteId: number | null;
  addressId: number;
  note: string;
  noteType: string;
  userOid: string | null;
  userEmail: string | null;
  userFullName: string | null;
  objectId: string | null;
  objectCreated: string;
  objectUpdated: string | null;
};

export type GetNotesResponse = {
  addressId: number;
  notes: AddressNote[];
};

export type UpdateNotesResponse = {
  addressId: number;
  note: string;
};